import styled from "styled-components";

export const EmptyState = styled.div`  
  padding: 32px 16px;
  background: var(--color-contrast-white);
  border: 1px solid var(--color-neutral-200, #e5e7eb);
  border-radius: 6px;
  text-align: center;
  color: var(--color-neutral-500, #6b7280);
  font-size: 14px;
`;
